import create from "zustand"
import { getDiscoveries, getDiscoveryDetail, markRead } from "../../networks/Discovery";

const DiscoveryStore = create((set, get) => {

  const setErrorAction = (isError, msg) => set({
    hasError: isError,
    errorMessage: msg
  })

  const getDiscoveriesAction = async () => {
    try {
      set({ isLoading: true })
      const response = await getDiscoveries()
      set({ 
        discoveries: response.data.notifications?.filter( noti => noti.message != null),
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
      setErrorAction(true, error.response?.data?.message || error.message);
    }
  }

  const getDiscoveryDetailAction = async (id) => {
    try {
      set({ isLoading: true })
      const response = await getDiscoveryDetail(id)
      set({ 
        discovery: response.data,
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
      setErrorAction(true, error.response?.data?.message || error.message);
    }
  }

  const markReadAction = async (id) => {
    try {
      set({ isLoading: true })
      await markRead(id)
      set({
        isLoading: false,
      })
    } catch (error) {
      set({ isLoading: false })
      setErrorAction(true, error.response?.data?.message || error.message);
    }
  }

  const clearAllAction = () => set({
    ...initState
  })

  const clearDiscoveryAction = () => set({
    discovery: null
  })

  const initState = {
    discoveries: [],
    discovery: null,
    result: null,
    isLoading: false,
    isformStep1Success: false,
    isSetDTOSuccess: false,
    hasError: false,
    errorMessage: '',
  }

  return {
    ...initState,
    getDiscoveries: getDiscoveriesAction,
    getDiscoveryDetail: getDiscoveryDetailAction,
    markRead: markReadAction,
    setError: setErrorAction,
    clearAll: clearAllAction,
    clearDiscovery: clearDiscoveryAction,
  }
});

export default DiscoveryStore;